export class EmailJSResponseStatus {
  constructor() {
    let _status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let _text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Network Error';
    this.status = _status;
    this.text = _text;
  }
}